import React from "react";
import {Query} from "react-apollo";
import {AffiliateQueryBac} from "../apollo/queries/AffiliateQuery";
import Spinner from "react-bootstrap/Spinner";
import InscriptionInput from "./InscriptionInput";
import Grades from "./Grades";
import {DegreesBacQuery} from "../apollo/queries/DegreesQuery";
import CiberAlerts, {MESSAGES} from "../util/Messages";
import {getDeviceId, getFormattedDate, getLoggedUser} from "../util/Utils";
import Beneficiaries from "./Beneficiaries";
import {Mutation} from "@apollo/react-components";
import {InscriptionBacMutation} from "../apollo/mutations/InscriptionMutation";
import ModalDateCorrection from "./ModalDateCorrection";
import InfoBac from "./InfoBac";
import FinalStep from "./FinalStep";

export default class InscriptionFormBacAffiliate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      birthDateCorrection: '',
      contactPhone: '',
      contactName: '',
      toInscription: true,
      beneficiary: {
        value: {
          birthDate: '',
          age: ''
        }
      },
      affiliateName: '',
      affiliateLastName: '',
      grade: {
        value: {
          levelId: '',
          programId: '',
          degreeId: '',
        }
      }
    }
  }

  setError(error) {
    this.setState({
      errorMessage: error
    });
  }

  handleChange = (e, label) => {
    console.log(e, label);
    if (label) {
      this.setState({
        [label]: e
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  };


  closeModal = () => {
    this.setState({
      showModal: false
    })
  };

  openModal = () => {
    this.setState({
      showModal: true
    })
  };

  onChangeBirthDate = (date) => {
    this.setState({
      birthDateCorrection: date,
    });
  };

  render() {
    return (
      <div className="card card-signin my-5 col-sm-6 border-left-0">
        <div className="card-body">
          <h1 className="card-title text-center">Inscripción a Cibercolegios</h1>
          {this.state.errorMessage ?
            <CiberAlerts error={this.state.errorMessage} callBack={this.openModal}/> :
            null
          }
          <Query query={AffiliateQueryBac} fetchPolicy={"network-only"}
            onError={(error) => {
              this.setError(error)
            }}
            onCompleted={data => {
              console.log(data);
              this.setState({
                affiliateName: data.bacAffiliation.name,
                affiliateLastName: data.bacAffiliation.lastName,
              })
            }}
          >
            {({loading, error, data}) => {
              if (loading) {
                return (<Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>);
              } else if (data) {
                let loggedUser = getLoggedUser();
                return (

                  <Mutation mutation={InscriptionBacMutation}
                    variables={this.state.toInscription ? {
                      dataInscription: {
                        beneficiaryDocType: this.state.beneficiary.value.documentType,
                        beneficiaryDocument: this.state.beneficiary.value.documentNumber,
                        affiliateName: this.state.affiliateName,
                        affiliateLastName: this.state.affiliateLastName,
                        levelId: this.state.grade.value.levelId,
                        programId: this.state.grade.value.programId,
                        degreeId: this.state.grade.value.degreeId,
                        birthDate: this.state.beneficiary.value.birthDate,
                        beneficiaryName: this.state.beneficiary.value.name,
                        beneficiaryLastName: this.state.beneficiary.value.lastName,
                        deviceId: getDeviceId(),
                        uuid: loggedUser?loggedUser.UID:null
                      }
                    } : {
                      dataInscription: {
                        beneficiaryDocType: this.state.beneficiary.value.documentType,
                        beneficiaryDocument: this.state.beneficiary.value.documentNumber,
                        birthDate: this.state.birthDateCorrection,
                        contact: this.state.contactName,
                        phoneContact: this.state.contactPhone,
                        beneficiaryName: this.state.beneficiary.value.name,
                        beneficiaryLastName: this.state.beneficiary.value.lastName,
                        affiliateName: this.state.affiliateName,
                        affiliateLastName: this.state.affiliateLastName,
                        deviceId: getDeviceId()
                      }
                    }}
                    onError={(error) => {
                      this.setState({
                        errorMessage: error
                      })
                    }}>
                    {(confirmInscription, result) => {

                      if (result.data && result.data.saveInscriptionBac && result.data.saveInscriptionBac.statusCode === "CIB-GEN-0200") {
                        if (result.data.saveInscriptionBac.redirectUrl) {
                          window.location.replace(result.data.saveInscriptionBac.redirectUrl)
                        } else {
                          return <FinalStep message={MESSAGES["SUCCESS_BAC"]} title="Inscripcion Cibercolegios"
                            internal={true}/>
                        }
                      }

                      const confirmDate = () => {
                        this.closeModal();

                        this.setState({
                          errorMessage: '',
                          toInscription: false
                        }, () => {
                          return confirmInscription()
                        });
                      };
                      return (
                        <>
                          <Beneficiaries beneficiaries={data.bacAffiliation.beneficiaries}
                            handleChange={this.handleChange}/>
                          <InscriptionInput value={getFormattedDate(this.state.beneficiary.value.birthDate)}
                            label="Fecha de Nacimiento" readOnly={true}/>
                          <InscriptionInput value={this.state.beneficiary.value.age} label="Edad"
                            readOnly={true}/>
                          <Grades grade={this.state.grade} service={DegreesBacQuery} variables={{}}
                            index="degreesBac" handleChange={this.handleChange}
                          />
                          <br/>
                          <button className="btn btn-lg btn-primary btn-block" type="button"
                            onClick={confirmInscription}
                            disabled={!this.state.beneficiary.value.documentNumber || !this.state.grade.value.levelId}
                          >
                            Diligenciar Inscripción {result.loading ? <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                          </Spinner> : ""}
                          </button>
                          <br/>
                          <InfoBac/>
                          <ModalDateCorrection
                            show={this.state.showModal}
                            handleClose={this.closeModal}
                            date={this.state.birthDateCorrection}
                            onChange={this.onChangeBirthDate}
                            onChangeContact={this.handleChange}
                            callBack={confirmDate}
                            withContactInfo={true}
                            contactName={this.state.contactName}
                            contactPhone={this.state.contactPhone}
                          />
                        </>
                      )

                    }}
                  </Mutation>
                );
              } else {
                return <></>
              }
            }}
          </Query>
        </div>
      </div>
    )
  }
}
